var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Stack from 'syf-component-library/ui/spacing/Stack';
import { translate } from '../../../strings/i18n';
import { HeaderContainer, HeaderTitle, Image, ImageContainer, SubTitle } from './subcomponents';
import { FAS_CIRCLE_INFO } from '../../../../../const/icon-props';
import MessageBox from '../../MessageBox';
import Icon from '../../icon';
import useGetImages from '../../../hooks/useGetImages';
var Header = function (_a) {
    var isPromoExtended = _a.isPromoExtended;
    var success = useGetImages().success;
    var imageTopSpacing = isPromoExtended ? 'xxlarge' : 'large';
    return (_jsxs(_Fragment, { children: [_jsx(Stack, { hideOnBreakpointUp: "medium" }), _jsxs(HeaderContainer, __assign({ top: "large", hideOnBreakpointDown: "medium" }, { children: [isPromoExtended && (_jsx(MessageBox, { type: "info", icon: _jsx(Icon, { title: "info circle icon", size: "lg", icon: FAS_CIRCLE_INFO }), title: translate('promosExtendedMessageBox.title'), body: translate('promosExtendedMessageBox.body') })), _jsx(ImageContainer, __assign({ top: imageTopSpacing, bottom: "large" }, { children: _jsx(Image, { src: success, alt: "success-image" }) })), _jsx(HeaderTitle, { children: translate('successfulScreen.title') }), _jsxs("div", { children: [_jsxs(SubTitle, { children: [translate('successfulScreen.subTitleOne'), "\u00A0"] }), _jsx(SubTitle, { children: translate('successfulScreen.subTitleTwo') })] })] }))] }));
};
export default Header;
